export const messageProxyConnectionErrorMessage = (service) => {
 return `Unable to connect to ${service} service, tags and filters will not function properly`
};